<template>
    <div v-if="isOpen" class="options__tooltip">
        <ul class="options__list">
            <li
                v-for="option in options"
                :key="option.id"
                class="options__list-item">
                {{ option.name }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'OptionsList',

    props: {
        options: {
            default: () => {
                return [];
            },
            type: Array
        },
        isOpen: {
            default: false,
            type   : Boolean
        }
    }
};
</script>
